/** @fileoverview Public barrel for the student "My tasks" module (AR-543). */

export { StudentTasksPage } from './StudentTasksPage'
